import { SolanaLogo } from "./SolanaLogo";

const phrases = [
  "SOLANA BULL MODE",
  "AS $SOL GOES, $CURB GOES",
  "$8 WAS THE GENERATIONAL BUY",
  "DON'T FADE THE BULL",
  "STAY CONSISTENT. STAY RESILIENT. STAY BULLISH.",
  "THE TRENCHES AREN'T PLAYING",
];

export const Marquee = () => (
  <div
    data-testid="marquee-banner"
    className="relative z-10 border-y border-[#9945FF]/30 bg-[#0a0714]/80 backdrop-blur-md py-3 overflow-hidden my-8"
  >
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center shrink-0">
          {phrases.map((p, i) => (
            <span key={`${dup}-${i}`} className="flex items-center gap-4 px-6">
              <span className="font-bebas tracking-[0.25em] text-xl text-zinc-200 whitespace-nowrap">
                {p}
              </span>
              <SolanaLogo size={18} />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
